@if (selectedTabDv === 3 && (werknemerEntity$ | async)) {
  @if (checkEinddatum()) {
    <snelstart-ui-button (click)="addRij()"
                         class="snelstart-ui-button mb-1"
                         icon="plus"
                         id="add"
                         type="link">Nieuwe periode toevoegen
    </snelstart-ui-button>
  }

  <form [formGroup]="lijstFg">
    <div formArrayName="roosterGegevens">
      @for (item of roosterGegevens.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="details-row">
            <div class="d-flex flex-wrap align-items-end gap-2">

              <div class="d-flex gap-2 align-items-end">
                <snelstart-ui-date-form-control
                  [disabledControl]="true"
                  [formControl]="item.controls.periode.controls.begindatum"
                  [label]="i === 0 ? 'Ingangsdatum' : ''"
                  class="custom-input-150"
                  id="begindatum6">
                </snelstart-ui-date-form-control>

                <snelstart-ui-date-form-control
                  [disabledControl]="hasGeldigeEinddatum(i)"
                  [formControl]="item.controls.periode.controls.einddatum"
                  [label]="i === 0 ? 'Einddatum' : ''"
                  class="custom-input-150"
                  id="einddatum6">
                </snelstart-ui-date-form-control>
              </div>

              <snelstart-ui-number-form-control
                [disabledControl]="hasGeldigeEinddatum(i)"
                [formControl]="item.controls.aantalUrenPerWeek"
                [label]="i === 0 ? 'Roosteruren per week' : ''"
                class="custom-input-150"
                id="aantalUrenPerWeek">
              </snelstart-ui-number-form-control>

              <snelstart-ui-number-form-control
                [disabledControl]="true"
                [formControl]="item.controls.normUren"
                [label]="i === 0 ? 'Normuren per week' : ''"
                class="custom-input-150"
                id="normUren">
              </snelstart-ui-number-form-control>

              @if (isActieveVerwijderbareRegel(i)) {
                <div class="btn-align-up-icon">
                  <snelstart-ui-button
                    (click)="verwijderRijRooster(i)"
                    icon="trash"
                    id="delete"
                    size="medium"
                    type="secondary">
                  </snelstart-ui-button>
                </div>
              }
            </div>
            @if (item.controls.periode.hasError('begindatumVoorDatumInDienst') || item.controls.periode.hasError('einddatumVoorBegindatum')) {
              <div class="mb-2" style="margin-top: -8px;">
                @if (item.controls.periode.hasError('begindatumVoorDatumInDienst')) {
                  <div class="text-danger small">Ingangsdatum mag niet vóór datum indienst liggen.</div>
                }
                @if (item.controls.periode.hasError('einddatumVoorBegindatum')) {
                  <div class="text-danger small">Einddatum mag niet vóór ingangsdatum liggen.</div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </form>
}
